export default {"src":"/_next/static/media/apple.5661bd34.svg","height":39,"width":32,"blurWidth":0,"blurHeight":0};